import { SelectInput } from '@interstate/components/SelectInput';

import { useMilesPerYearField } from './hooks/useMilesPerYearField';

const MilesPerYearField = ({ isSummaryTab }: { isSummaryTab?: boolean }) => {
    const { label, selectProps } = useMilesPerYearField({ isSummaryTab });

    return <SelectInput id="MilesPerYear" label={label} {...selectProps} />;
};

export default MilesPerYearField;
